﻿var ko = require("knockout");
var komap = require("knockout.mapping");

(function () {
    ko.dirtyFlag = function(root, initializer, isInitiallyDirty) {
        var rt = root;
        var init = initializer;

        var result = function() { };
        var _initialState = ko.observable(komap.toJSON(rt));
        var _isInitiallyDirty = ko.observable(isInitiallyDirty);

        result.isDirty = ko.pureComputed(function() {
            return _isInitiallyDirty() || _initialState() !== komap.toJSON(rt);
        });

        result.reset = function() {
            _initialState(komap.toJSON(rt));
            _isInitiallyDirty(false);
        };

        result.revert = function() {
            if (typeof initializer === "function") {
                init(ko.utils.parseJson(_initialState()));
                _isInitiallyDirty(false);
            }
        };

        result.rebind = function(newRoot, newInit, initiallyDirty) {
            rt = newRoot;
            init = newInit;
            _initialState(komap.toJSON(rt));
            _isInitiallyDirty(initiallyDirty);
        };

        //TODO store dirty fields in SessionStorage/localstorage

        return result;
    };
})();
